import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';

const normalizePaymentMeans = (paymentMeans) => {
  if (!paymentMeans) return [];
  if (Array.isArray(paymentMeans)) return paymentMeans;
  if (typeof paymentMeans === 'object') return [paymentMeans];
  return [];
};
export const fetchProformaInvoice = async (query) => {
  const { data } = await apiClient.get(`/proforma-invoices/${query.queryKey[1]}`);
  return data;
};

export const useGetProformaInvoiceHandler = (id) => {
  const dispatch = useDispatch();
  const [invoice, setInvoice] = useState(undefined);

  const {
    data: fetchedData,
    isLoading,
    isFetching,
    isError,
    error,
  } = useQuery({
    queryKey: ['proforma-invoice', id], // A unique key for this query
    queryFn: fetchProformaInvoice,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
  });

  useEffect(() => {
    if (fetchedData) {
      setInvoice({
        ...fetchedData,
        payment_means: normalizePaymentMeans(fetchedData.payment_means),
      });
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      if (error instanceof AxiosError) {
        if (error.status) {
          dispatch(showSnackbar({ message: error.response.data.message, severity: 'error' }));
        } else {
          dispatch(showSnackbar({ message: error.message, severity: 'error' }));
        }
      } else {
        dispatch(showSnackbar({ message: JSON.stringify(error), severity: 'error' }));
      }
    }
  }, [dispatch, error, isError]);

  return {
    invoice: invoice,
    isLoading,
  };
};
